import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';

import { Message, MessageInfo, MessageHelper, MessageInfoHelper } from '../../models/b2b/message';
import { User } from '../../models/b2b/user';
import { ApiService } from '../api/api.service';
import { map } from 'rxjs/operators';
import { validateApiResponse } from 'app/shared/lib/custom-rxjs-operators/api-response.operator';

@Injectable()
export class SoledadMessagesService {
    constructor(private api: ApiService) {}

    /**
     * Get all messages for user logged
     *
     * @param {User} user
     *
     * @returns void (Updates observable messages and messagesUnread)
     *
     * @memberOf MessagesService
     */
    getAll(clienteCodigo: string, selectedAddress: number): Observable<MessageInfo> {
        // console.log('getAll', {user});
        const info: MessageInfo = MessageInfoHelper.create();

        if (!clienteCodigo) {
            return of(info);
        }

        // Params
        const params = [];
        params['DIRECCIONENVIO'] = selectedAddress;

        // Call
        return this.api.callSoledad('b2bNew.dbo.HTML_MensajesLeer', params).pipe(
            validateApiResponse('Error obteniendo mensajes' + '. Params: ' + JSON.stringify(params)),
            map((res) => {
                // console.log('HTML_MensajesLeer', {res});
                // res = MessageHelper.mock();
                const newsRead = JSON.parse(localStorage.getItem(clienteCodigo + 'news_read')) || [];
                const allMessages = res.map((row: any) => MessageHelper.transformFromApi(row));
                const news = [];

                info.messages = allMessages.filter(
                    (message) =>
                        (message.type === 'OBLIGADA_LECTURA' || message.type === 'ALERTA') && message.read === false
                );

                info.messagesNews = allMessages.filter(
                    (message) => message.type === 'ULTIMAS_NOTICIAS' && newsRead.indexOf(message.id) < 0
                );

                info.unread = info.messages.filter((message) => message.type !== 'ULTIMAS_NOTICIAS' && !message.read);

                info.messagesNews.map((message) => news.push(message.id));

                if (news.length) {
                    // Uncomment to check if message was readed by user
                    // localStorage.setItem(user.clienteCodigo + 'news_read', JSON.stringify(news));
                }

                return info;
            })
        );
    }

    /**
     * Mark message as read
     *
     * @param {Message} readMessage
     *
     * @returns {Observable<boolean>}
     */
    readMessage(readMessage: Message): Observable<boolean> {
        // console.log('readMessage', {readMessage});

        const params = [];
        params['MENSAJE'] = readMessage.id;

        // Call
        return this.api.callSoledad('b2bNew.dbo.HTML_MensajesMarcar', params).pipe(
            map((res) => {
                // console.log('HTML_MensajesMarcar', {res});
                return res.result === 0 && res.value && res.value.length > 0 && res.value[0].ME_RESULTADO === 0;
            })
        );
    }

    getNotifications(clienteCodigo: string): Observable<any> {
        const params = [];
        params['CLIENTE'] = clienteCodigo;

        return this.api.callSoledad('b2bNew.dbo.HTML_NotificacionesLeer', params).pipe(
            map((res) => {
                if (res && res.result === 0 && res.value) {
                    return res.value;
                }
                return of([]);
            })
        );
    }
    markNotificationsAsRead(ids: string) {
        const params = [];
        params['NOTIFICACIONES'] = ids;

        return this.api.callSoledad('b2bNew.dbo.HTML_NotificacionesMarcarLeida', params).pipe(
            map((res) => {
                if (res && res.result === 0 && res.value && res.value === 'OK') {
                    return res.value;
                }

                throwError({ message: 'error', value: [] });
            })
        );
    }

    markNotificationsAsUnread(ids: string) {
        const params = [];
        params['NOTIFICACIONES'] = ids;
        params['LEIDA'] = false;

        return this.api.callSoledad('b2bNew.dbo.HTML_NotificacionesMarcarLeida', params).pipe(
            map((res) => {
                if (res && res.result === 0 && res.value && res.value === 'OK') {
                    return res.value;
                }

                throwError({ message: 'error', value: [] });
            })
        );
    }
}
